import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, CalendarStateToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackHeight, StackType, StackWidth, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { horizontalStepperRepo } from '../../../../configs/utils';
import { RegexConfig } from '../../../../configs/config';
import { ACTION } from './types';
import { GoBack, NavToNextStep, toggleCTA, ValidateForm } from './action';
import { Platform } from "react-native";
export const template = (stepper, panNumber, dob) => {
    return {
        layout: {
            id: ROUTE.CO_BORROWER_PAN,
            type: LAYOUTS.LIST,
            widgets: [
                Platform.OS === "ios" ? { id: "spaceXXL", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
                {
                    id: 'header',
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                { id: 'space0', type: WIDGET.SPACE },
                { id: 'detailTitle', type: WIDGET.TEXT },
                { id: 'space3', type: WIDGET.SPACE },
                { id: 'mobileNumberInput', type: WIDGET.INPUT },
                { id: 'space4', type: WIDGET.SPACE },
                { id: 'emailInput', type: WIDGET.INPUT },
                { id: 'space1', type: WIDGET.SPACE },
                { id: 'input', type: WIDGET.INPUT },
                { id: 'space2', type: WIDGET.SPACE },
                { id: 'calendarStack', type: WIDGET.STACK },
                Platform.OS !== 'web' ? { id: 'keyboardSpace', type: WIDGET.SPACE } : {},
                Platform.OS !== 'web' ? { id: 'keyboardSpace', type: WIDGET.SPACE } : {},
                Platform.OS !== 'web' ? { id: 'keyboardSpace', type: WIDGET.SPACE } : {},
                {
                    id: 'bottomStack',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ],
        },
        datastore: {
            spaceXXXXL: {
                size: SizeTypeTokens.XXXXXXL
            },
            space0: { size: SizeTypeTokens.MD },
            header: {
                id: 'bt_coBorrowerPan_goBack',
                title: 'Joint holder details',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.CO_BORROWER_PAN,
                    payload: {},
                },
            },
            detailTitle: {
                label: 'Provide basic details of joint holder',
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.MD,
                color: ColorTokens.Grey_Night,
                fontWeight: '600',
                lineHeight: 24,
            },
            keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
            keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
            keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
            space1: {
                size: SizeTypeTokens.XXXL,
            },
            input: {
                id: 'tf_coBorrowerPan_pan',
                regex: RegexConfig.PAN,
                value: panNumber,
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                charLimit: 10,
                title: 'PAN of joint holder',
                placeholder: 'Enter PAN of joint holder',
                keyboardType: KeyboardTypeToken.default,
                isFocus: false,
                isUpperCase: true,
                action: {
                    type: ACTION.VALIDATE_FORM,
                    payload: { value: '', widgetId: 'input' },
                    routeId: ROUTE.CO_BORROWER_PAN,
                },
                caption: {
                    success: '',
                    error: 'Please enter a valid PAN number',
                },
            },
            space2: {
                size: SizeTypeTokens.XL,
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            calendarStack: {
                width: StackWidth.MATCH_PARENT,
                type: StackType.column,
                widgetItems: [
                    { id: "calendarPicker", type: WIDGET.CALENDAR_PICKER },
                    { id: 'spaceXXXXL', type: WIDGET.SPACE },
                    { id: 'spaceXXXXL', type: WIDGET.SPACE },
                    Platform.OS !== 'web' ? { id: 'spaceXXXXL', type: WIDGET.SPACE } : { id: 'spaceXXL', type: WIDGET.SPACE },
                    Platform.OS !== 'web' ? { id: 'spaceXXL', type: WIDGET.SPACE } : {},
                ]
            },
            calendarPicker: {
                year: {
                    id: 'tf_coBorrowerPan_year',
                    title: 'Year',
                    value: `${dob.substring(6)}`,
                    placeholder: 'YYYY'
                },
                month: {
                    id: 'tf_coBorrowerPan_month',
                    title: 'Month',
                    value: `${dob.substring(3, 5)}`,
                    placeholder: 'MM'
                },
                date: {
                    id: 'tf_coBorrowerPan_date',
                    title: 'Date',
                    value: `${dob.substring(0, 2)}`,
                    placeholder: 'DD'
                },
                state: CalendarStateToken.DEFAULT,
                caption: {
                    success: '',
                    error: 'Age should be between 18 and 100',
                    default: 'Date of birth as per PAN of joint holder',
                },
                action: {
                    type: ACTION.VALIDATE_FORM,
                    payload: {
                        value: '',
                        widgetId: 'calendarPicker',
                    },
                    routeId: ROUTE.CO_BORROWER_PAN,
                },
            },
            space3: {
                size: SizeTypeTokens.XL,
            },
            mobileNumberInput: {
                id: 'tf_coBorrowerPan_mobileNumber',
                regex: RegexConfig.MOBILE,
                value: '',
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                charLimit: 10,
                isFocus: true,
                title: 'Mobile number of joint holder',
                placeholder: 'Enter Mobile number of joint holder',
                keyboardType: KeyboardTypeToken.numberPad,
                action: {
                    type: ACTION.VALIDATE_FORM,
                    payload: {
                        value: '',
                        widgetId: 'mobileNumberInput',
                    },
                    routeId: ROUTE.CO_BORROWER_PAN,
                },
                caption: {
                    success: '',
                    error: 'Enter a valid mobile number.',
                },
            },
            space4: {
                size: SizeTypeTokens.XL,
            },
            emailInput: {
                id: 'tf_coBorrowerPan_email',
                regex: RegexConfig.NEW_EMAIL,
                value: '',
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                isFocus: false,
                title: 'Email of joint holder',
                placeholder: 'Enter Email of joint holder',
                keyboardType: KeyboardTypeToken.default,
                action: {
                    type: ACTION.VALIDATE_FORM,
                    payload: {
                        value: '',
                        widgetId: 'emailInput',
                    },
                    routeId: ROUTE.CO_BORROWER_PAN,
                },
                caption: {
                    success: '',
                    error: 'Enter a valid email.',
                },
            },
            bottomStack: {
                height: StackHeight.CONTENT,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'continueCTA', type: WIDGET.BUTTON },
                    { id: 'spaceBelowContinue', type: WIDGET.SPACE },
                ],
            },
            continueCTA: {
                id: 'bt_coBorrowerPan_continue',
                label: 'Continue',
                type: ButtonTypeTokens.LargeOutline,
                width: ButtonWidthTypeToken.FULL,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.MD,
                lineHeight: SizeTypeTokens.XXL,
                fontWeight: '700',
                action: {
                    type: ACTION.NAV_TO_NEXT_STEP,
                    routeId: ROUTE.CO_BORROWER_PAN,
                    payload: {},
                },
            },
            spaceBelowContinue: { size: SizeTypeTokens.MD },
        },
    };
};
export const coBorrowerPan = {
    onLoad: async ({ network }) => {
        const stepper = await horizontalStepperRepo(network);
        const pan = '';
        const dob = "";
        return Promise.resolve(template(stepper, pan, dob));
    },
    actions: {
        [ACTION.GO_BACK]: GoBack,
        [ACTION.VALIDATE_FORM]: ValidateForm,
        [ACTION.NAV_TO_NEXT_STEP]: NavToNextStep,
        [ACTION.TOGGLE_CTA]: toggleCTA,
    },
    clearPrevious: true,
};
